import { map as _map, flatMap as _flatMap, filter as _filter } from 'lodash';
import { CART_PRODUCT_TYPES } from "../../constants/index.js";
import { getActivityLabel, getFlightTravellerLabel, getAddonsLabel, getHotelLabel, getHotelName, getHotelTourismFees } from "../products.utils/index.js";
import { formatPriceOnlyValue } from "../format.utils/index.js";
export function reArangeCarts(carts) {
  var parentCarts = _filter(carts, function (c) {
    return c.relatedToCart === null;
  });
  var child = _filter(carts, function (c) {
    return c.relatedToCart !== null;
  });
  var arrangeCartsObj = [];
  parentCarts.forEach(function (p) {
    arrangeCartsObj.push(p);
    arrangeCartsObj.push.apply(arrangeCartsObj, _filter(child, function (o) {
      return o.relatedToCart.cartId === p.cartId;
    }));
  });
  return arrangeCartsObj;
}
export function reArangeOrders(orders) {
  var parentCarts = _filter(orders, function (c) {
    return c.relatedToOrder === null;
  });
  var child = _filter(orders, function (c) {
    return c.relatedToOrder !== null;
  });
  var arrangeCartsObj = [];
  parentCarts.forEach(function (p) {
    arrangeCartsObj.push(p);
    arrangeCartsObj.push.apply(arrangeCartsObj, _filter(child, function (o) {
      return o.relatedToOrder.orderId === p.orderId;
    }));
  });
  return arrangeCartsObj;
}
export function getHotelLineItem(lineItems, total, keyToReadPrice, product) {
  return _map(lineItems, function (line) {
    return {
      label: getHotelName(product),
      labelObj: getHotelLabel(product),
      price: {
        currency: total.currency,
        total: formatPriceOnlyValue(line.price[keyToReadPrice])
      },
      type: 'hotel-sku',
      productBreakdown: [],
      isNegetiveRule: line.price[keyToReadPrice] < 0
    };
  });
}
export function getActivityLineItem(lineItems, total, includeTotalWithVat, product) {
  var totalKey = includeTotalWithVat ? 'totalWithVat' : 'total';
  return _flatMap(lineItems, function (line) {
    return _map(line.breakdown, function (breakdown) {
      return {
        label: getActivityLabel(breakdown, product),
        price: {
          currency: total.currency,
          total: formatPriceOnlyValue(breakdown[totalKey])
        },
        type: 'activity-sku',
        productBreakdown: [],
        isNegetiveRule: false
      };
    });
  });
}
export function getAddOnsLineItem(lineItems, total, keyToReadPrice, product) {
  return _map(lineItems, function (line) {
    return {
      label: getAddonsLabel(product),
      price: {
        currency: total.currency,
        total: formatPriceOnlyValue(line.price[keyToReadPrice])
      },
      type: 'addons-sku',
      productBreakdown: [],
      isNegetiveRule: line.price[keyToReadPrice] < 0
    };
  });
}
export function getFlightLineItem(lineItems, total, flightProduct) {
  return _flatMap(lineItems, function (line) {
    return _map(line.breakdown, function (breakdown) {
      return {
        label: getFlightTravellerLabel(breakdown, flightProduct),
        price: {
          currency: total.currency,
          total: formatPriceOnlyValue(breakdown.total)
        },
        type: 'flights-sku',
        productBreakdown: breakdown !== null && breakdown !== void 0 && breakdown.details && (breakdown === null || breakdown === void 0 ? void 0 : breakdown.details.length) > 0 ? flightProductBreakdownLines(breakdown === null || breakdown === void 0 ? void 0 : breakdown.details, total) : [],
        isNegetiveRule: false
      };
    });
  });
}
function flightProductBreakdownLines(details, total) {
  return _map(details, function (detail) {
    return {
      label: detail === null || detail === void 0 ? void 0 : detail.key,
      price: {
        currency: total === null || total === void 0 ? void 0 : total.currency,
        total: formatPriceOnlyValue(detail === null || detail === void 0 ? void 0 : detail.amount)
      },
      type: detail === null || detail === void 0 ? void 0 : detail.key
    };
  });
}
export function getProductLineItem(lineItems, total, keyToReadPrice, product, includeTotalWithVat) {
  var flightLineItem = getFlightLineItem(_filter(lineItems, function (l) {
    return (l === null || l === void 0 ? void 0 : l.type) === CART_PRODUCT_TYPES.FLIGHT;
  }), total, product);
  var hotelLineItem = getHotelLineItem(_filter(lineItems, function (l) {
    return (l === null || l === void 0 ? void 0 : l.type) === CART_PRODUCT_TYPES.HOTEL;
  }), total, keyToReadPrice, product);
  var activityLineItem = getActivityLineItem(_filter(lineItems, function (l) {
    return (l === null || l === void 0 ? void 0 : l.type) === CART_PRODUCT_TYPES.ACTIVITIES;
  }), total, includeTotalWithVat, product);
  var addOnsLineItem = getAddOnsLineItem(_filter(lineItems, function (l) {
    return l.type !== CART_PRODUCT_TYPES.FLIGHT && l.type !== CART_PRODUCT_TYPES.HOTEL && l.type !== CART_PRODUCT_TYPES.RULE && l.type !== CART_PRODUCT_TYPES.VAT && l.type !== CART_PRODUCT_TYPES.ACTIVITIES;
  }), total, keyToReadPrice, product);
  return [].concat(flightLineItem, hotelLineItem, activityLineItem, addOnsLineItem);
}
export function getTotalBreakDownLineItem(total) {
  return [{
    label: 'vat',
    type: 'vat',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.vat)
    }
  }, {
    label: 'subTotal',
    type: 'subTotal',
    price: {
      currency: total === null || total === void 0 ? void 0 : total.currency,
      total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.subTotal)
    }
  }];
}
export function getTotalLineItem(total, isPostSale, hasMultiCart, saleTotal) {
  var totalObj;
  if (hasMultiCart) {
    totalObj = {
      label: 'total',
      type: 'total',
      price: {
        currency: total === null || total === void 0 ? void 0 : total.currency,
        total: formatPriceOnlyValue(isPostSale ? total === null || total === void 0 ? void 0 : total.total : total === null || total === void 0 ? void 0 : total.totalToBePaid)
      }
    };
  } else {
    totalObj = {
      label: isPostSale ? 'overall-total' : 'totalToBePaid',
      type: isPostSale ? 'overall-total' : 'totalToBePaid',
      price: {
        currency: total.currency,
        total: formatPriceOnlyValue(isPostSale ? saleTotal.total : saleTotal.totalToBePaid)
      }
    };
  }
  return [totalObj];
}
export function getRulesLineItem(lineItems, total, keyToReadPrice) {
  return _map(lineItems, function (line) {
    return {
      label: line === null || line === void 0 ? void 0 : line.name,
      price: {
        currency: total === null || total === void 0 ? void 0 : total.currency,
        total: formatPriceOnlyValue(line === null || line === void 0 ? void 0 : line.price[keyToReadPrice])
      },
      type: line === null || line === void 0 ? void 0 : line.type,
      productBreakdown: [],
      isNegetiveRule: (line === null || line === void 0 ? void 0 : line.price[keyToReadPrice]) < 0
    };
  });
}
export function getExtraLineItem(product, type) {
  var extraLines = [];
  if (type === CART_PRODUCT_TYPES.HOTEL) {
    extraLines.push(getHotelTourismFees(product));
  }
  return extraLines;
}
export function getSalePaymentLineItem(payments, keyToReadPrice, currency, total, hasMultiCart) {
  var salePayment = [];
  var loyaltyPayments = _filter(payments, function (p) {
    return p.type === CART_PRODUCT_TYPES.LOYALTY;
  });
  if (loyaltyPayments.length > 0) {
    salePayment.push({
      label: hasMultiCart ? 'overall-total' : 'total',
      type: hasMultiCart ? 'overall-total' : 'total',
      price: {
        currency: total === null || total === void 0 ? void 0 : total.currency,
        total: formatPriceOnlyValue(total === null || total === void 0 ? void 0 : total.total)
      }
    });
  }
  _map(loyaltyPayments, function (line) {
    salePayment.push({
      id: line === null || line === void 0 ? void 0 : line.id,
      label: line === null || line === void 0 ? void 0 : line.category,
      price: {
        currency: currency,
        total: formatPriceOnlyValue(line === null || line === void 0 ? void 0 : line.price[keyToReadPrice])
      },
      type: line === null || line === void 0 ? void 0 : line.category,
      isNegetiveRule: true
    });
  });
  return salePayment;
}